import { IssueType } from "../issue/issue.types"
import { AAACallData } from "./calls.types"

export const RAP_PROGRAM_CODES = {
  CADDILAC_CELESTIQ: '850'
}

// TODO: handle this on the backend
export const overrideCadillacCelestiqPacesetterCode = (receivingClubCode: string, callData: AAACallData) => {
  if (receivingClubCode === RAP_PROGRAM_CODES.CADDILAC_CELESTIQ && callData.vehicle.model.toUpperCase() === 'CELESTIQ' && callData.service.issueType === IssueType.NEED_A_TOW) {
    callData.service.pacesetterCode = 'T680'
  }
}
